// Module
var code = "<template> <require from=\"./list-layout.scss\"></require> <div class=\"list-layout-items\"> <slot></slot> </div> </template> ";
// Exports
module.exports = code;